import BlogThirtyNineContainer from "./container/BlogThirtyNineContainer";
export default BlogThirtyNineContainer;
